export enum CommonUrlQueryKeys {
  ENV = 'env',
  LANG = 'lang',
  APP_FLAVOR = 'appFlavor',
  HWID = 'hwid',
  UNIT_SYSTEM = 'unit',
}
